import { CardType, cardTypes } from "../data/allTypes";

export function IconTab({
  activeTabId,
  id,
  isHorizontal = false,
  name,
  icon,
  color: color,
  onChange,
  children,
}: {
  activeTabId: string | null | undefined;
  id: string | null | undefined;
  isHorizontal?: boolean;
  name: string;
  icon?: any;
  color?: CardType;
  onChange: (tab: string) => void;
  children?: any;
}) {
  let typeInfo = color ? cardTypes[color] : null;
  let isActive = activeTabId == id;

  return (
    <div
      className={`tab center tcenter ${isActive ? "active" : ""} ${
        isHorizontal ? "horizontal" : ""
      } relative`}
      style={{ background: isActive ? typeInfo?.secondaryColor || "" : "" }}
      onClick={() => {
        onChange(id || "");
      }}
    >
      {icon != null && (
        <span style={{ color: isActive ? typeInfo?.color : "" }}>{icon}</span>
      )}
      {children || (
        <div
          className="title"
          style={{ color: isActive ? typeInfo?.color : "" }}
        >
          {name}
        </div>
      )}
    </div>
  );
}
